import { Popover } from '@mantine/core';
import { ReactComponent as IconDownload } from '../ContractItem/img/iconDownload.svg';
import { ReactComponent as IconKebab } from '../ContractItem/img/iconKebab.svg';
import styles from './ReferenceActions.module.scss';
import { WorkerReference } from 'redux/Api/referencesApi/type';
import { useState } from 'react';
import { ModalConfirm } from 'components/ContractItem/ModalConfirm';
import { REFERENCE_MODAL_MESSAGES } from 'pages/EmployedsProfileContent/EmployedsProfileContentDesktop';
import { getFileNameFromContentDisposition } from 'utils/strActions';

export interface ReferenceActionsProps {
  reference: WorkerReference;
  workerId: string | undefined;
}

export const ReferenceActions: React.FC<ReferenceActionsProps> = ({
  reference: _reference, // eslint-disable-line @typescript-eslint/no-unused-vars
  workerId,
}) => {
  const [opened, setOpened] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showReferenceModal, setShowReferenceModal] = useState(false);
  const [referenceModalContent, setReferenceModalContent] = useState<{
    title: string;
    text: string;
  }>({ title: '', text: '' });

  const isDisabledLoadReference = !isDownloading;

  const handleDownload = async () => {
    if (!workerId) {
      console.error('Worker ID is required for download');
      return;
    }

    if (isDisabledLoadReference) {
      try {
        setIsDownloading(true);
        const token = localStorage.getItem('token');
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/docs/registration-reference/${workerId}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          },
        );

        if (!response.ok) {
          throw new Error('Ошибка при запросе справки');
        }

        const disposition = response.headers.get('content-disposition');
        const blob = await response.blob();
        const fileName =
          getFileNameFromContentDisposition(disposition) || 'registration-reference.pdf';

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        setReferenceModalContent(REFERENCE_MODAL_MESSAGES.ERROR_DOWNLOAD_REFERENCE);
        setShowReferenceModal(true);
      } finally {
        setIsDownloading(false);
        setOpened(false);
      }
    }
  };

  return (
    <>
      <Popover
        width={330}
        position='bottom-end'
        radius={'4px'}
        opened={opened}
        onChange={setOpened}>
        <Popover.Target>
          <IconKebab
            className={styles.kebabIcon}
            onClick={() => setOpened((prevOpened: boolean) => !prevOpened)}
          />
        </Popover.Target>
        <Popover.Dropdown
          p='4px 0'
          style={{
            borderRadius: '4px',
            boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
            border: 'none',
          }}>
          <div
            className={styles.item}
            onClick={handleDownload}
            style={{ opacity: isDownloading ? 0.6 : 1 }}>
            <IconDownload />
            <span>{isDownloading ? 'Загрузка...' : 'Скачать справку'}</span>
          </div>
        </Popover.Dropdown>
      </Popover>
      {showReferenceModal && (
        <ModalConfirm
          setShowLogoutModal={setShowReferenceModal}
          title={referenceModalContent.title}
          onConfirm={() => setShowReferenceModal(false)}
          text={referenceModalContent.text}
          cancelText='Закрыть'
        />
      )}
    </>
  );
};
